// src/components/.../LoadFeedDialog.js
import * as React from 'react';
import Tab from '@mui/material/Tab';

import * as WrcCommon from '@webrcade/app-common';

import { GlobalHolder } from '../../Global';
import Editor from '../common/editor/Editor';
import EditorTabPanel from '../common/editor/EditorTabPanel';
import FeedsTable from './FeedsTable';

// 🔹 i18n
import { useI18n } from '../../i18n/I18nContext';

const setTabValue = () => {};

export default function LoadFeedDialog(props) {
  const [isOpen, setOpen] = React.useState(false);
  const [feeds, setFeeds] = React.useState(null);

  const { t } = useI18n(); // 🔹 hook de tradução

  GlobalHolder.setLoadFeedDialogOpen = setOpen;

  const loadTab = 0;

  const onOk = () => {
    return true;
  };

  return (
    <Editor
      // 🔹 "Load Feed"
      title={t('loadFeedDialogTitle')}
      height={400}
      isOpen={isOpen}
      setOpen={setOpen}
      tabValue={loadTab}
      setTabValue={setTabValue}
      closeButton={true}
      BackdropProps={{
        sx: {
          // Make darker due to table over table
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
        },
      }}
      onShow={async () => {
        const feeds = await WrcCommon.loadFeeds(0);
        setFeeds(feeds);
      }}
      onOk={onOk}
      onSubmit={() => {
        if (onOk()) {
          setOpen(false);
        }
      }}
      tabs={[
        // 🔹 Aba "Load"
        <Tab label={t('loadFeedDialogTabLoad')} key={loadTab} />,
      ]}
      tabPanels={
        <>
          <EditorTabPanel value={loadTab} index={loadTab}>
            <FeedsTable
              feeds={feeds}
              setOpen={setOpen}
              onDelete={async () => {
                const feeds = await WrcCommon.loadFeeds(0);
                setFeeds(feeds);
              }}
            />
          </EditorTabPanel>
        </>
      }
    />
  );
}